// Icona SFA (Servizio Formazione Autonomie): sagoma essenziale di una persona
// con freccia verso l'alto integrata nel corpo (crescita, sviluppo, autonomia).
// Stile lucide (stroke currentColor, viewBox 24). Uso: <SfaIcon className="h-5 w-5 ..." />
export const SfaIcon = ({ className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <circle cx="12" cy="4.5" r="2.5" />
    <path d="M12 20V8.5" />
    <path d="M8 12l4-4 4 4" />
    <path d="M8.5 20h7" />
  </svg>
);

export default SfaIcon;
